export default function validateInfo(values, imageProp) {
    let errors = {};

    if (!values.user_name.trim()) {
      errors.username = 'Podaj Imię';
    }
    if (!values.user_surname.trim()) {
      errors.surname = 'Podaj nazwisko';
    }
    if (!values.user_position.trim()) {
      errors.position = 'Podaj stanowisko';
    }
    if (!values.user_email) {
      errors.email = 'Podaj adres email';
    } else if (!/\S+@\S+\.\S+/.test(values.user_email)) {
      errors.email = 'Podaj prawidłowy adres email';
    }

    if (!values.user_phone) {
    } else if (!/^[0-9\b]+$/.test(values.user_phone)) {
      errors.phone = 'Wpisz tylko cyfry bez spacji';
    } else if (values.user_phone.trim().length !== 9) {
      errors.phone = 'Wpisz 9 cyfrowy numer bez spacji';
    }

    if(imageProp) {
      if (!values.user_image) {
        errors.image = 'Zanim przejdziesz dalej wybierz swoje zdjęcie lub awatar';
        console.log('errors', errors)
      }
    }

    return errors;
  }